import instanceSettingsApi from './instanceSettingsApi';

const getInstanceSettings = async () => {
  try {
    const { data } = await instanceSettingsApi.get('/');
    return data;
  } catch (error) {
    console.error('[getInstanceSettings] Failed:', error);
    throw error;
  }
};

export default getInstanceSettings;
